import { useTranslation } from 'react-i18next'

import { Box, Text } from '@enechain/ecloud-designsystem'

import type { ApproverIdentity } from '~/pages/SpotBidding/models/approverIdentity'
import { buildApproverStandingNotices } from '~/pages/SpotBidding/models/approverIdentity'

/** 承認状態バナーの承認・差戻しボタンの近くに常時出す注意 (AC-BSP-098 (a))。 */
export const ApproverIdentityNotice = ({
  identity,
}: {
  identity: ApproverIdentity
}): React.ReactElement | null => {
  const { t } = useTranslation()
  const notices = buildApproverStandingNotices(identity, t)
  if (notices.length === 0) return null
  return (
    <Box marginTop={1}>
      {notices.map((notice) => (
        <Text key={notice} fontSize="sm">
          {notice}
        </Text>
      ))}
    </Box>
  )
}
